<ng-container *ngIf="status">
    <p>{{ 'INIT.ERROR.' + status | translate }}</p>
    <div class="row">
        <div translate class="col-2 f-b">INIT.STATUS</div>
        <div class="col-10">{{ status }}</div>
    </div>
    <div class="row">
        <div translate class="col-2 f-b">INIT.MSG</div>
        <div class="col-10">{{ message }}</div>
    </div>
</ng-container>

<ng-container *ngIf="!status">

    <ng-container *ngIf="!isLicenceValid">
        <p>{{ 'INIT.STEP_LICENCE' | translate }}</p>
        <mat-form-field class="w-100" appearance="outline">
            <mat-label>{{ 'INIT.STEP_LICENCE_LABEL' | translate }}</mat-label>
            <textarea matInput
                    [formControl]="licenceControl"
                    cdkTextareaAutosize
                    #autosize="cdkTextareaAutosize"
                    cdkAutosizeMinRows="4"
                    cdkAutosizeMaxRows="20">
            </textarea>
        </mat-form-field>
        <div>
            <button mat-button (click)="validateLicence(stepper, licenceControl.value)" [disabled]="loading || !licenceControl.valid" color="primary">{{ 'GENERIC.VALIDATE' | translate }}</button>
        </div>
    </ng-container>
    <div *ngIf="isLicenceValid" class="success">
        <mat-icon aria-hidden="false">{{ 'GENERIC.DONE' | translate }}</mat-icon> <span class="step-text"> {{ 'INIT.STEP_LICENCE_OK' | translate }} </span>
        <br>
        <br>
        <button mat-raised-button color="primary" *ngIf="isLicenceValid" [routerLink]="['/init','account']">{{ 'GENERIC.NEXT' | translate }}</button>
    </div>

    
</ng-container>